import { render, staticRenderFns } from "./SDA.vue?vue&type=template&id=08d19edd&"
import script from "./SDA.vue?vue&type=script&lang=ts&"
export * from "./SDA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports